





































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import currencyFormatter from 'currency-formatter'
import { CURRENCY_DEFAULT } from '@/constants/currency'

@Component
export default class BigAmount extends Vue {
    @Prop({ required: true, type: Number }) value!: number
    @Prop({
      required: false,
      type: String,
      validator: function (v: string) {
        return ['currency', 'percentage'].indexOf(v) !== -1
      }
    }) type!: string | undefined

    @Prop({ required: false, type: String, default: CURRENCY_DEFAULT }) currency!: string

    @Prop({ required: false, type: Boolean, default: false }) showPlusMinusSymbol!: boolean

    MINUS_SYMBOL = '\u2212'
    PLUS_SYMBOL = '+'

    decimalSeparator = ''
    spaceBetweenAmountAndSymbol = false
    symbol = ''
    symbolOnLeft = false
    formattedValue = ''
    integerValue = ''
    decimalValue = ''
    optionalSpacing = ''

    @Watch('value')
    onValueChanged (value: number) {
      if (this.type === 'currency') {
        this.handleCurrency(value, this.currency)
      }

      if (this.type === 'percentage') {
        this.handlePercentage(value)
      }
    }

    handleCurrency (value: number, currency: string) {
      const Currency = currencyFormatter.findCurrency(currency)

      const formattedValue = currencyFormatter.format(Math.abs(value), {
        code: currency,
        symbol: ''
      })

      const [integerValue, decimalValue] = formattedValue.split(Currency.decimalSeparator)
      const optionalSpacing = Currency.spaceBetweenAmountAndSymbol ? ' ' : ''

      this.decimalSeparator = Currency.decimalSeparator
      this.spaceBetweenAmountAndSymbol = Currency.spaceBetweenAmountAndSymbol
      this.symbol = Currency.symbol
      this.symbolOnLeft = Currency.symbolOnLeft
      this.formattedValue = formattedValue
      this.integerValue = integerValue
      this.decimalValue = decimalValue
      this.optionalSpacing = optionalSpacing
    }

    handlePercentage (value: number) {
      this.formattedValue = Math.abs(value).toFixed(2)
    }

    mounted () {
      if (this.type === 'currency') {
        this.handleCurrency(this.value, this.currency)
      }

      if (this.type === 'percentage') {
        this.handlePercentage(this.value)
      }
    }
}

